export class NotificationPolicyConfigSns {
    'topicArn';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "topicArn",
            "baseName": "topicArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NotificationPolicyConfigSns.attributeTypeMap;
    }
    constructor() {
    }
}
